module.exports = __webpack_public_path__ + "img/AppGallery.aef9bedf.png";